import { TranslateService } from '@ngx-translate/core';
import { isObservable, map } from 'rxjs';
import { translationDisplayText } from './translation-display-text.util';

const patchedServices = new WeakSet<TranslateService>();

/**
 * ngx-translate returns the nested object when a title key also has dotted children
 * (fieldCatalogue + fieldCatalogue.clearOptions*). The translate pipe then prints
 * [object Object]. Patch once so instant / get / stream / | translate all unwrap.
 */
export function installTranslationObjectUnwrap(translate: TranslateService): void {
  if (patchedServices.has(translate)) {
    return;
  }
  patchedServices.add(translate);

  const original = translate.getParsedResult.bind(translate);
  translate.getParsedResult = ((key: string | string[], interpolateParams?: object) => {
    const result = original(key, interpolateParams);
    return unwrapParsedResult(key, result, translate.getCurrentLang?.());
  }) as TranslateService['getParsedResult'];
}

export function unwrapParsedResult(
  key: string | string[],
  result: unknown,
  lang?: string | null,
): unknown {
  if (isObservable(result)) {
    return result.pipe(map((value) => unwrapParsedResult(key, value, lang)));
  }

  if (Array.isArray(key)) {
    if (result && typeof result === 'object' && !Array.isArray(result)) {
      const source = result as Record<string, unknown>;
      const out: Record<string, string> = {};
      for (const itemKey of key) {
        out[itemKey] = translationDisplayText(source[itemKey], itemKey, lang);
      }
      return out;
    }
    return result;
  }

  return translationDisplayText(result, key, lang);
}
